import styled, { keyframes } from 'styled-components';

const roller = keyframes`
  100% { transform: rotate(360deg); }
`;

const dot = keyframes`
  80%, 100% { transform: rotate(360deg); }
`;

const dotBefore = keyframes`
  50% {
    transform: scale(0.4); 
  }
  100%, 0% {
    transform: scale(1.0); 
  } 
`;

export const Roller = styled.div`
  position: relative;
  width: 14px;
  height: 14px;
  animation: ${roller} 2.5s infinite linear both;
  margin-left: 3px;
`;

export const Dot = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  animation: ${dot} 2s infinite ease-in-out both;
  &:before {
    content: '';
    display: block;
    width: 4px;
    height: 4px;
    background-color: var(--color-grey97);
    border-radius: 2px;
    animation: ${dotBefore} 2s infinite ease-in-out both;
  }
  &:nth-child(1) {
    animation-delay: -1.1s;
  }
  &:nth-child(2) {
    animation-delay: -1s;
  }
  &:nth-child(3) {
    animation-delay: -0.9s;
  }
  &:nth-child(4) {
    animation-delay: -0.8s;
  }
  &:nth-child(5) {
    animation-delay: -0.7s;
  }
  &:nth-child(6) {
    animation-delay: -0.6s;
  }
  &:nth-child(1):before {
    animation-delay: -1.1s;
  }
  &:nth-child(2):before {
    animation-delay: -1s;
  }
  &:nth-child(3):before {
    animation-delay: -0.9s;
  }
  &:nth-child(4):before {
    animation-delay: -0.8s;
  }
  &:nth-child(5):before {
    animation-delay: -0.7s;
  }
  &:nth-child(6):before {
    animation-delay: -0.6s;
  }
`;
